export function buildProductSummary(product) {
  const parts = [];

  parts.push(product.name);
  parts.push(product.category);
  if (product.variant) parts.push(product.variant);
  parts.push(product.brand);

  if (product.fit) parts.push(`fit:${product.fit}`);
  if (product.budgetTier) parts.push(`tier:${product.budgetTier}`);

  if (Array.isArray(product.styleTags)) {
    parts.push(`style:${product.styleTags.join(",")}`);
  }

  return parts.filter(Boolean).join(" | ");
}